import { gql } from '@apollo/client';
import { AUDIT_LOG_FRAGMENT } from 'data/fragments/auditLog';

export const AUDIT_LOG_CREATED_SUBSCRIPTION = gql`
    subscription AUDIT_LOG_CREATED($collectionDocumentId: String!) {
        auditLogCreated(collectionDocumentId: $collectionDocumentId) {
            ...AuditLogFragment
        }
    }
    ${AUDIT_LOG_FRAGMENT}
`;
